// Recovered compiled webpack factory 51755. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  function n(e) {
    return e;
  }
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    Object.defineProperty(t, "removeBasePath", {
      enumerable: !0,
      get: function () {
        return n;
      },
    }),
    r(92929),
    ("function" == typeof t.default || ("object" == typeof t.default && null !== t.default)) &&
      void 0 === t.default.__esModule &&
      (Object.defineProperty(t.default, "__esModule", { value: !0 }),
      Object.assign(t.default, t),
      (e.exports = t.default)));
}
